import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export const margin = byMedia(value => `margin: ${getPx(value)};`);
export const marginHalf = byMedia(value => `margin: calc(${getPx(value)} / 2);`);